import { render, staticRenderFns } from "./SportCategories.vue?vue&type=template&id=04d081e4&scoped=true&"
import script from "./SportCategories.vue?vue&type=script&lang=js&"
export * from "./SportCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d081e4",
  null
  
)

export default component.exports